import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
export default {
  name: 'Description',
  props: {
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};